import { Toast } from 'antd-mobile';
import { noop } from './index';

const showMessage = (content = '', duration = 2, onClose = noop, mask = true) => {
  Toast.info(content, duration, onClose, mask);
};

const showLoading = (content = '加载中...', duration = 0, onClose = noop, mask = true) => {
  Toast.loading(content, duration, onClose, mask);
};

const closeLoading = () => {
  Toast.hide();
};

export { showMessage, showLoading, closeLoading };
